import { isServer } from '@ulta/core/utils/device_detection/device_detection';

/**
 * Checks if the element is visible in viewport
 *
 * @param {HTMLElement} element html element
 * @return {boolean} returns true or false as per visibility of elements in viewport
 */
export const isInViewport = ( data ) =>{
  const { element } = data || {};

  if( isServer() || typeof element?.getBoundingClientRect !== 'function' ){
    return false;
  }

  const rect = element?.getBoundingClientRect();

  return (
    rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= ( global?.innerHeight || document?.documentElement?.clientHeight ) &&
      rect.right <= ( global?.innerWidth || document?.documentElement?.clientWidth )
  );
};
